/* eslint-disable new-cap */
/* eslint node/no-callback-literal: "off" */
/* eslint node/handle-callback-err: "off" */
/*

FUNCIONES COMUNES

*/

const isSmallDevice = function () {
  if (window.innerWidth <= 800 || window.innerHeight <= 600) {
    return true
  }
  return false
}

const ObjectId = function (m, d, h, s) {
  if (m === void 0) {
    m = Math
  }
  if (d === void 0) {
    d = Date
  }
  if (h === void 0) {
    h = 16
  }
  if (s === void 0) {
    s = function (s) {
      return m.floor(s).toString(h)
    }
  }
  return s(d.now() / 1000) + ' '.repeat(h).replace(/./g, function () {
    return s(m.random() * h)
  })
}

let cookieMode = 'cookie'

const setCookieMode = (vtrue) => {
  cookieMode = vtrue ? 'cookie' : 'session'
}

const setCookie = function (cname, cvalue, exdays) {
  if (cookieMode === 'cookie') {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + d.toGMTString()
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  } else {
    sessionStorage.setItem(cname, cvalue)
  }
}

const getCookie = function (cname) {
  if (cookieMode === 'cookie') {
    const name = cname + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
  } else {
    const va = sessionStorage.getItem(cname)
    return va === null ? '' : va
  }
  return ''
}
/*
const getSessionId = () => {
    var jsId = document.cookie.match(/JSESSIONID=[^;]+/);
    if (jsId != null) {
        if (jsId instanceof Array)
            jsId = jsId[0].substring(11);
        else
            jsId = jsId.substring(11);
    }
    // Caso que no tenemos ID - Usar UID
    return getCookie('gb-wbchtbt-uid');
};
*/

/**
 * Transform no clean rut into clean rut
 * @param {String} rutc rut
 * @returns clean rut
 */
const limpiaRut = (rutc) => {
  if (!rutc) return rutc
  return rutc.trim().split('-').join('').split('.').join('')
}

const validaRut = (rutc) => {
  if (!rutc) return false
  rutc = rutc.trim().split('-').join('').split('.').join('')
  const rutnospace = rutc
  rutc = rutc.trim().substring(0, rutc.length - 1) + '-' + rutc.substring(rutc.length - 1, rutc.length)
  if (rutc.length < 9) return false
  const dv = function (T) {
    let M = 0
    let S = 1
    for (; T; T = Math.floor(T / 10)) {
      S = (S + T % 10 * (9 - M++ % 6)) % 11
    }
    return S ? S - 1 : 'k'
  }
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutc)) return false
  const tmp = rutc.split('-')
  let digv = tmp[1]
  const rut = tmp[0]
  if (digv === 'K') digv = 'k'
  if (String(dv(rut)) === digv) return rutnospace
  return false
}

const formatearRut = (rut) => {
  if (!rut) return rut
  let rutPuntos = ''
  const actual = rut.replace(/^0+/, '').replace(/ /, '')
  if (actual !== '' && actual.length > 1) {
    const sinPuntos = actual.replace(/\./g, '')
    const actualLimpio = sinPuntos.replace(/-/g, '')
    const inicio = actualLimpio.substring(0, actualLimpio.length - 1)
    let i = 0
    let j = 1
    for (i = inicio.length - 1; i >= 0; i--) {
      const letra = inicio.charAt(i)
      rutPuntos = letra + rutPuntos
      if (j % 3 === 0 && j <= inicio.length - 1) {
        rutPuntos = '.' + rutPuntos
      }
      j++
    }
    const dv = actualLimpio.substring(actualLimpio.length - 1)
    rutPuntos = rutPuntos + '-' + dv
  }
  return rutPuntos.toUpperCase()
}

const html2pdf = (strHtml, fileName) => {
  const doc = new JsPDF('p', 'pt', 'letter')
  const specialElementHandlers = {
    '#editor': function (/* element, renderer */) {
      return true
    }
  }
  doc.fromHTML(strHtml, 30, 30, { width: 500, elementHandlers: specialElementHandlers })
  doc.save(fileName + '.pdf')
}

const getLocation = (callback, callbackError) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      const lng = position.coords.longitude
      const lat = position.coords.latitude
      if (callback && typeof callback === 'function') return callback({ longitude: lng, latitude: lat })
      // eslint-disable-next-line no-unused-vars
    }, function (error) {
      if (callbackError && typeof callbackError === 'function') return callbackError(true)
    })
  } else {
    if (callback && typeof callback === 'function') return callback(null)
  }
}
/**
 * Transform number with dots to number with commas
 * "12.000" => 12,000 || 12.000 => 12
 * @param {String} num number to format
 * @returns {String}
 */
const formatNumberDotsCommas = (num) => {
  if (!num) return ''
  if (isNaN(num)) return ''
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(/\./g, '_').replace(/,/g, '.').replace(/_/g, ',')
}

/**
 * Transform number with commas to number with dots
 * "12.000" => 12,000 || 12.000 => 12
 * @param {String} num number to format
 * @returns {String}
 */
const formatedDotsCommasToNumber = (num) => {
  if (!num) return ''
  const _num = num.toString().replace(/\./g, '').replace(/,/g, '.')
  if (!isNaN(_num)) return Number(_num)
  return _num
}

const isEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

const cleanSpecialChars = (val, type) => {
  if (!val) return val
  if (type === 'name') return val.replace(/[^A-Za-zÀ-ÿ ]+$/g, '')
  if (type === 'paises') return val.replace(/[^a-zA-ZÀ-ÿ.,; ]/g, '')
  if (type === 'email') return val.replace(/[^a-zA-Z0-9\-_@.]/g, '')
  if (type === 'phone') return val.replace(/[^0-9]/g, '')
  if (type === 'rut') return val.replace(/[^0-9-Kk.]/g, '').replace(/\//, '').replace(/:/, '')
  if (type === 'comment') return val.replace(/[^a-zA-Z0-9À-ÿ. ;,¿?¡!$%]/g, '')
  if (type === 'numbers') return val.replace(/[^0-9]/g, '')
  if (type === 'orderNumber') return val.replace(/[^a-zA-ZÀ-ÿ0-9-]/g, '')
  if (type === 'dbsOrderNumber') return val.replace(/[^0-9]/g, '')

  return val.replace(/[^a-zA-ZÀ-ÿ0-9;,.: ]/g, '')
}

const checkSpecialChars = (val, type) => {
  if (!val) return val
  return (val === cleanSpecialChars(val, type))
}

const keyPressCheckSpecialChars = (evt, type) => {
  evt = (evt) || window.event
  const strCompare = evt.key
  if (strCompare !== cleanSpecialChars(strCompare, type)) {
    evt.preventDefault()
  } else {
    return true
  }
}

const onlyNumbersInput = (evt) => {
  const key = window.event ? evt.which : evt.keyCode
  if (key < 48 || key > 57) {
    evt.preventDefault()
  } else {
    return true
  }
}

const b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || ''
  sliceSize = sliceSize || 512
  const byteCharacters = atob(b64Data)
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

const textTransform = (value) => {
  let result = ''
  for (let i = 0; i < value.length; i++) {
    if (i < value.length - 1) {
      result += value.charCodeAt(i) + 12
      result += 'X'
    } else {
      result += value.charCodeAt(i) + 12
    }
  }
  return result
}

const inputTypeToText = (_input) => {
  if (!_input || !_input.type) return ''
  let sysMsg = _input.type.replace(/-/g, ' ').replace(/_/g, ' ')
  if (_input.type === 'buscarSucursalCercana') sysMsg = 'Opción Buscar Sucursal Cercana'
  if (_input.type === 'buscarSucursal') sysMsg = 'Opción Buscar Sucursal'
  if (_input.type === 'html2pdf') sysMsg = 'Opción Descargar Documento'
  if (_input.type === 'base64pdf') sysMsg = 'Opción Descargar Documento'
  if (_input.type === 'base64img') sysMsg = 'Opción Descargar Documento'
  if (_input.type === 'form') sysMsg = 'Opción Inicio de Sesión'
  if (_input.type === 'action-login') sysMsg = 'Opción Inicio de Sesión'
  if (_input.type === 'action-nearest-branch') sysMsg = 'Enviando ubicación'
  if (_input.type === 'form-get-data') sysMsg = 'Obtener Datos'
  if (_input.type === 'contact-form') sysMsg = 'Opción Formulario de Contacto'
  if (_input.type === '5f4697a061afb01ad9edf806-cotizar-form') sysMsg = 'Opción Formulario de Cotización'
  if (_input.type === '5f4697a061afb01ad9edf806-cotizar-form-confirm') sysMsg = 'Comfirmación Formulario de Cotización'
  if (_input.type === 'buscarAnfitrionaCercana') sysMsg = 'Buscando a la anfitriona Club ALVI más cercana...'
  if (_input.type === 'action-nearest-hostess') sysMsg = 'Buscando a la anfitriona Club ALVI más cercana...'
  if (_input.type === 'alvi-contacto-form') sysMsg = 'Opción Formulario de Contacto'
  if (_input.type === 'alvi-contacto-form-confirm') sysMsg = 'Confirmación Formulario de Contacto'
  if (_input.type === 'client-goodbye') sysMsg = 'Despedida'
  if (_input.type === 'alvi-contacto-form') sysMsg = 'Opción Inicio de Sesión'
  if (_input.type === 'alvi-contacto-form-confirm') sysMsg = 'Confirmación Inicio de Sesión'
  if (_input.type === '5f4697a061afb01ad9edf806-diaslibres-form') sysMsg = 'Opción Formulario Días Libres'
  // GENERAL
  if (_input.type === 'form-login-skip') sysMsg = 'Omitir Ingreso de datos'
  if (_input.type === 'form-login') sysMsg = 'Opción Ingreso de datos'
  if (_input.type === 'gatblac-form-contact') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'gatblac-form-contact-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // TUA
  if (_input.type === 'tua-dudas-compra') sysMsg = 'Solicitud Formulario Dudas Compra'
  if (_input.type === 'tua-dudas-compra-confirm') sysMsg = 'Confirmación Formulario Dudas Compra'
  if (_input.type === 'tua-problemas-compra') sysMsg = 'Solicitud Formulario Problemas Compra'
  if (_input.type === 'tua-problemas-compra-confirm') sysMsg = 'Confirmación Formulario Problemas Compra'
  if (_input.type === 'tua-devolucion-pedidos') sysMsg = 'Solicitud Formulario Devolución Pedidos'
  if (_input.type === 'tua-devolucion-pedidos-confirm') sysMsg = 'Confirmación Formulario Devolución Pedidos'
  if (_input.type === 'tua-contacto') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'tua-contacto-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // UNIBAG
  if (_input.type === 'unibag-cotizar-form') sysMsg = 'Solicitud Formulario Cotización'
  if (_input.type === 'unibag-cotizar-form-confirm') sysMsg = 'Confirmación Formulario Cotización'
  // CCU
  if (_input.type === 'ccu-servicio-tecnico-form') sysMsg = 'Solicitud Formulario Servicio Técnico'
  if (_input.type === 'ccu-servicio-tecnico-form-confirm') sysMsg = 'Confirmación Formulario Servicio Técnico'
  if (_input.type === 'ccu-ventas-form') sysMsg = 'Solicitud Formulario Ventas'
  if (_input.type === 'ccu-ventas-form-confirm') sysMsg = 'Confirmación Formulario Ventas'
  if (_input.type === 'ccu-otros-form') sysMsg = 'Solicitud Formulario Otros'
  if (_input.type === 'ccu-otros-form-confirm') sysMsg = 'Confirmación Formulario Otros'
  if (_input.type === 'ccu-distribucion-form') sysMsg = 'Solicitud Formulario Distribución'
  if (_input.type === 'ccu-distribucion-form-confirm') sysMsg = 'Confirmación Formulario Distribución'
  if (_input.type === 'ccu-reclamo-form') sysMsg = 'Solicitud Formulario Reclamo'
  if (_input.type === 'ccu-reclamo-form-confirm') sysMsg = 'Confirmación Formulario Reclamo'
  if (_input.type === 'ccu-reclamo-camion-form') sysMsg = 'Solicitud Formulario Reclamo Camion'
  if (_input.type === 'ccu-reclamo-camion-form-confirm') sysMsg = 'Confirmación Formulario Reclamo Camion'
  if (_input.type === 'ccu-reclamo-otros-form') sysMsg = 'Solicitud Formulario Reclamo Otros'
  if (_input.type === 'ccu-reclamo-otros-form-confirm') sysMsg = 'Confirmación Formulario Reclamo Otros'
  if (_input.type === 'ccu-camion-otros-form') sysMsg = 'Solicitud Formulario Contacto Otros'
  if (_input.type === 'ccu-camion-otros-form-confirm') sysMsg = 'Confirmación Formulario Contacto Otros'
  if (_input.type === 'ccu-reclamo-otros-form-labarra-confirm') sysMsg = 'Confirmación Formulario La Barra'
  if (_input.type === 'ccu-reclamo-otros-form-maquina-confirm') sysMsg = 'Confirmación Formulario Máquina Vending'
  if (_input.type === 'ccu-reclamo-otros-form-cliente-confirm') sysMsg = 'Confirmación Formulario Contacto'
  if (_input.type === 'ccu-creccu-form') sysMsg = 'Solicitud Formulario CRECCU'
  if (_input.type === 'ccu-creccu-form-confirm') sysMsg = 'Confirmación Formulario CRECCU'
  if (_input.type === 'ccu-reclamo-otros-form-labarra') sysMsg = 'Solicitud Formulario La Barra'
  if (_input.type === 'ccu-reclamo-otros-form-maquina') sysMsg = 'Solicitud Formulario Máquina Vending'
  if (_input.type === 'ccu-reclamo-otros-form-cliente') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'ccu-camion-otros-form-confirm-supplier') sysMsg = 'Confirmación Formulario Proveedor'
  if (_input.type === 'ccu-camion-otros-form-confirm-donation') sysMsg = 'Confirmación Formulario Donación'
  if (_input.type === 'ccu-camion-otros-form-confirm-auspice') sysMsg = 'Confirmación Formulario Auspicio'
  if (_input.type === 'ccu-camion-otros-supplier-form') sysMsg = 'Solicitud Formulario Proveedor'
  if (_input.type === 'ccu-camion-otros-donation-form') sysMsg = 'Solicitud Formulario Donación'
  if (_input.type === 'ccu-camion-otros-auspice-form') sysMsg = 'Solicitud Formulario Auspicio'
  // DBSHOP
  // KROSS
  if (_input.type === 'kross-form-delivery-delay') sysMsg = 'Solicitud Formulario Demora de Entrega'
  if (_input.type === 'kross-form-delivery-delay-confirm') sysMsg = 'Confirmación Formulario Demora de Entrega'
  if (_input.type === 'kross-form-damaged-product') sysMsg = 'Solicitud Formulario Producto Dañado'
  if (_input.type === 'kross-form-damaged-product-confirm') sysMsg = 'Confirmación Formulario Producto Dañado'
  if (_input.type === 'kross-form-wrong-product') sysMsg = 'Solicitud Formulario Producto Erróneo'
  if (_input.type === 'kross-form-wrong-product-confirm') sysMsg = 'Confirmación Formulario Producto Erróneo'
  if (_input.type === 'kross-form-new-client') sysMsg = 'Solicitud Formulario Producto Erróneo'
  if (_input.type === 'kross-form-new-client-confirm') sysMsg = 'Confirmación Formulario Producto Erróneo'

  // CACEM
  if (_input.type === 'cacem-form-contact') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'cacem-form-contact-confirm') sysMsg = 'Confirmación Formulario Contacto'

  // REALME
  if (_input.type === 'realme-form-technical-service') sysMsg = 'Solicitud Formulario Servicio Tecnico'
  if (_input.type === 'realme-form-technical-service-confirm') sysMsg = 'Confirmación Formulario Servicio Tecnico'
  if (_input.type === 'realme-form-product-executive') sysMsg = 'Solicitud Formulario de Comunicación con Experto de Productos'
  if (_input.type === 'realme-form-product-executive-confirm') sysMsg = 'Confirmación Formulario de Comunicación con Experto de Productos'

  // TRIAL
  if (_input.type === 'trial-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'trial-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // Nuam
  if (_input.type === 'nuam-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'nuam-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'
  if (_input.type === 'nuam-leads-form') sysMsg = 'Solicitud Formulario Captación de leads'
  if (_input.type === 'nuam-leads-form-confirm') sysMsg = 'Confirmación Formulario Captación de leads'
  // Bsx
  if (_input.type === 'bsx-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'bsx-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // A2censo
  if (_input.type === 'a2censo-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'a2censo-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // Bvc
  if (_input.type === 'bvc-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'bvc-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'
  // Bvl
  if (_input.type === 'bvl-contact-form') sysMsg = 'Solicitud Formulario Contacto'
  if (_input.type === 'bvl-contact-form-confirm') sysMsg = 'Confirmación Formulario Contacto'

  return sysMsg
}

const formatDateReverse = (date) => {
  if (!date) return
  return date.split('-').reverse().join('-')
}

const logicalOperator = (numb1, numb2, operator) => {
  numb1 = Number(numb1)
  numb2 = Number(numb2)
  switch (operator) {
    case '>':
      return numb1 > numb2
    case '<':
      return numb1 < numb2
    case '=':
      return numb1 === numb2
    case '>=':
      return numb1 >= numb2
    case '<=':
      return numb1 <= numb2
    default:
      break
  }
}

export default {
  ObjectId,
  setCookieMode,
  setCookie,
  getCookie,
  isSmallDevice,
  limpiaRut,
  validaRut,
  formatearRut,
  html2pdf,
  getLocation,
  formatNumberDotsCommas,
  formatedDotsCommasToNumber,
  isEmail,
  checkSpecialChars,
  cleanSpecialChars,
  keyPressCheckSpecialChars,
  b64toBlob,
  inputTypeToText,
  textTransform,
  formatDateReverse,
  onlyNumbersInput,
  logicalOperator
}
